// extracted by mini-css-extract-plugin
export var root = "P-l4";
export var rootActions = "DaN3";
export var rootBody = "e1In";
export var rootButton = "ohuc";
export var rootButtonHeading = "_6dyr";
export var rootButtons = "-wek";
export var rootImage = "WR0D";
export var rootPicture = "_4DRP";